import type { RouteRecordRaw } from 'vue-router'

export const selectCompanyRoute: RouteRecordRaw = {
  path: '/selecionar-empresa',
  name: 'selecionar-empresa',
  component: async () => await import('./pages/SelectCompanyPage.vue'),
  meta: {
    requiresAuth: true,
  },
}

export const companySettingsRoute: RouteRecordRaw = {
  path: '/configuracoes',
  name: 'configuracoes',
  component: async () => await import('./pages/CompanySettingsPage.vue'),
}
